module.exports = __webpack_public_path__ + "img/n8.4dbb0d5d.jpeg";